import { useEffect, useState } from 'react';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useIntersectionObserver, useTranslation } from '@hooks';
import { ListingServices } from '@services';

const useProducts = (query, loadMore) => {
    const [pageMeta, setPageMeta] = useState(null);
    const { currency } = useTranslation();
    const {
        category,
        keyword,
        categories,
        q,
        colour,
        priceMin,
        priceMax,
        size,
        order,
        pageSize,
    } = query;

    // get category id from slug
    const categoryIDRes = useQuery({
        queryKey: ['categoryID', category],
        queryFn: () => ListingServices.getCategoryID(category),
        enabled: !!category,
    });
    const categoryID = categoryIDRes?.data?.data?.id || null;
    const { data, fetchNextPage, hasNextPage, isLoading } = useInfiniteQuery({
        queryKey: [
            'products',
            keyword,
            q,
            categoryID,
            priceMin,
            priceMax,
            size,
            colour,
            categories,
            order,
            currency,
            pageSize,
        ],
        queryFn: ({ pageParam = 1 }) =>
            ListingServices.getProducts({
                pageParam,
                keyword,
                q,
                categoryID,
                priceMin,
                priceMax,
                size,
                colour,
                order,
                categories,
                currency,
                pageSize,
            }),
        getNextPageParam: ({ meta }) => meta?.next_page,
        enabled: typeof categoryID === 'number',
    });

    // This will run fetch when user scroll to end
    useIntersectionObserver({
        target: loadMore,
        onIntersect: fetchNextPage,
        enabled: hasNextPage,
    });

    useEffect(() => {
        if (data) {
            setPageMeta(data?.pages[data.pages.length - 1]?.meta);
        }
    }, [data]);
    return { data, hasNextPage, isLoading, pageMeta, fetchNextPage };
};

export default useProducts;
